module.exports = __webpack_public_path__ + "static/media/M1-36-Tempestade-Arcana-cod155.7f9a5adb.png";